import React from 'react';
import clsx from 'clsx';
import formStyles from '../../../../components/form/form.module.scss';
import { Input } from '../../../../components/uikit/inputs/Input.tsx';
import { MenuItem, Select } from '@mui/material';
import { FeatureFlags } from '../../../../application/constants/env-variables.ts';
import { Button } from '../../../../components/uikit/buttons/Button.tsx';
import { NegativeActionText } from '../../../../components/uikit/NegativeActionText.tsx';
import { FilterProps } from '../OrderList.tsx';
import { useScopedTranslation } from '../../../../application/localization/useScopedTranslation.ts';
import ArrowDown from 'assets/icons/arrow-down-selector.svg?react';
import styles from '../OrderList.module.scss';
import { IconButton } from '../../../../components/uikit/IconButton.tsx';
import Cross from 'assets/icons/close-button-small.svg?react';
import { tDynamic } from '../../../../helpers/tDynamic.ts';

export const Filters = (props: FilterProps) => {
  const {
    form,
    selectState,
    periodOptions,
    ordersPeriodType,
    directionOptions,
    deliveryPeriodDirection,
    deliveryPeriodType,
    isResetButtonShow,
    resetFilters,
    changeSelectionState,
    ordersAmountOfPeriods,
    deliveryAmountOfPeriods,
    orderNumber,
    reference,
  } = props;

  const i18n = useScopedTranslation('Page.OrderList');

  return (
    <form onSubmit={form.handleSubmitDefault}>
      <div className={clsx(formStyles.rowContainer, styles.filterContainer)}>
        <div className={clsx(formStyles.rowContainer, styles.alignItemsUnset)}>
          <Input
            testId={'time-interval-order-input'}
            className={clsx(styles.width84)}
            leftHelperText={i18n.t('orders_for_last')}
            {...form.register('ordersAmountOfPeriods')}
            type={'number'}
            endAdornment={
              <div>
                {ordersAmountOfPeriods && (
                  <IconButton
                    type={'destroy'}
                    onClick={() => form.setValue('ordersAmountOfPeriods', null)}
                  >
                    <Cross />
                  </IconButton>
                )}
              </div>
            }
            endAdornmentClassname={styles.endAdornmentClassname}
          />
          <Select
            data-test-id={'order-period-select'}
            open={selectState.ordersPeriodType}
            onClick={() => {
              changeSelectionState({ ordersPeriodType: true });
            }}
            onClose={(e) => {
              e.stopPropagation();
              changeSelectionState({ ordersPeriodType: false });
            }}
            value={ordersPeriodType}
            onChange={(e) => form.setValue('ordersPeriodType', e.target.value)}
            className={formStyles.select}
            IconComponent={ArrowDown}
            MenuProps={{
              PaperProps: {
                className: formStyles.selectBody,
              },
              disableScrollLock: true,
            }}
          >
            {periodOptions.map((periodOption) => (
              <MenuItem key={periodOption} value={periodOption}>
                {tDynamic(i18n, periodOption)}
              </MenuItem>
            ))}
          </Select>
        </div>
        <div className={clsx(formStyles.rowContainer, styles.alignItemsUnset)}>
          <div className={styles.greyText}>{i18n.t('delivery_date')}</div>
          <Select
            data-test-id={'delivery-direction-select'}
            open={selectState.deliveryPeriodDirection}
            onClick={() => {
              changeSelectionState({ deliveryPeriodDirection: true });
            }}
            onClose={(e) => {
              e.stopPropagation();
              changeSelectionState({ deliveryPeriodDirection: false });
            }}
            value={deliveryPeriodDirection}
            onChange={(e) =>
              form.setValue('deliveryPeriodDirection', e.target.value)
            }
            className={clsx(formStyles.select, styles.width92)}
            IconComponent={ArrowDown}
            MenuProps={{
              PaperProps: {
                className: clsx(formStyles.selectBody, styles.width92),
              },
              disableScrollLock: true,
            }}
          >
            {directionOptions.map((periodOption) => (
              <MenuItem key={periodOption} value={periodOption}>
                {tDynamic(i18n, periodOption)}
              </MenuItem>
            ))}
          </Select>
          <Input
            testId={'time-interval-delivery-input'}
            className={clsx(styles.width84)}
            {...form.register('deliveryAmountOfPeriods')}
            type={'number'}
            endAdornment={
              <div>
                {deliveryAmountOfPeriods && (
                  <IconButton
                    type={'destroy'}
                    onClick={() =>
                      form.setValue('deliveryAmountOfPeriods', null)
                    }
                  >
                    <Cross />
                  </IconButton>
                )}
              </div>
            }
            endAdornmentClassname={styles.endAdornmentClassname}
          />
          <Select
            open={selectState.deliveryPeriodType}
            onClick={() => {
              changeSelectionState({ deliveryPeriodType: true });
            }}
            onClose={(e) => {
              e.stopPropagation();
              changeSelectionState({ deliveryPeriodType: false });
            }}
            value={deliveryPeriodType}
            onChange={(e) =>
              form.setValue('deliveryPeriodType', e.target.value)
            }
            className={formStyles.select}
            IconComponent={ArrowDown}
            MenuProps={{
              PaperProps: {
                className: formStyles.selectBody,
              },
              disableScrollLock: true,
            }}
          >
            {periodOptions.map((periodOption) => (
              <MenuItem key={periodOption} value={periodOption}>
                {tDynamic(i18n, periodOption)}
              </MenuItem>
            ))}
          </Select>
        </div>
        <Input
          testId={'order-number-input'}
          className={clsx(styles.width120)}
          leftHelperText={i18n.t('order_number')}
          {...form.register('orderNumber')}
          endAdornment={
            <div>
              {orderNumber && (
                <IconButton
                  type={'destroy'}
                  onClick={() => form.setValue('orderNumber', '')}
                >
                  <Cross />
                </IconButton>
              )}
            </div>
          }
          endAdornmentClassname={styles.endAdornmentClassname}
        />
        {FeatureFlags.isReferenceSearchEnabled() && (
          <Input
            testId={'reference-input'}
            className={clsx(styles.width160)}
            leftHelperText={i18n.t('your_reference')}
            {...form.register('reference')}
            endAdornment={
              <div>
                {reference && (
                  <IconButton
                    type={'destroy'}
                    onClick={() => form.setValue('reference', '')}
                  >
                    <Cross />
                  </IconButton>
                )}
              </div>
            }
            endAdornmentClassname={styles.endAdornmentClassname}
          />
        )}
        <Button
          type={'submit'}
          className={clsx(formStyles.actionButton)}
          title={i18n.t('apply')}
          testId={'filters-apply-button'}
        />
        {isResetButtonShow && (
          <NegativeActionText
            text={i18n.t('reset')}
            onClickHandler={resetFilters}
            testId={'filters-reset-button'}
          />
        )}
      </div>
    </form>
  );
};
